import type { ReactElement, ReactNode } from 'react';
import { HelpTip } from './HelpTip';
import './ControlRow.css';

/**
 * One setting as a row (2026-09-12 拍板, the same anatomy everywhere a setting
 * lives): title with the ? that opens its plain-words explanation, a line or
 * two of state beneath, and the control — a Switch, or whatever the setting
 * is — on the right. Settings and the owner's Ember page draw their rows
 * with this so the two read as one system.
 */
export function ControlRow({ title, helpKey, help, detail, control, unavailable = false }: {
  title: string;
  /** Which setting, on settings_help_open. */
  helpKey: string;
  /** The explanation the ? opens. Plain words; a paragraph or two. */
  help: ReactNode;
  /** The state line(s) under the title. */
  detail?: ReactNode;
  control: ReactNode;
  /** The setting cannot be turned on here: title and detail go tertiary with the switch's third look. */
  unavailable?: boolean;
}): ReactElement {
  return (
    <li className={`control-row${unavailable ? ' is-unavailable' : ''}`}>
      <div className="control-row-text">
        <span className="control-row-title">
          {title}
          <HelpTip which={helpKey} label={title}>{help}</HelpTip>
        </span>
        {detail}
      </div>
      {control}
    </li>
  );
}
